import {useFormik} from "formik";
import {useDispatch, useSelector} from "react-redux";
import {RouteConstant} from "@/util/constant/RouteConstant";
import {RootState} from "@/store";
import {BaseInput} from "@/components/input/BaseInput";
import {useNavigate} from "react-router-dom";
import {invite} from "@/store/modules/invite.ts";
import {
    InviteRegistrationRequest,
    InviteRegistrationRequestInit
} from "@/model/request/invite/InviteRegistrationRequest.ts";
import {InviteRegistrationResponse} from "@/model/response/invite/InviteRegistrationResponse.ts";
import {auth} from "@/store/modules/auth.ts";
import {application} from "@/store/modules/application.ts";
import {workspace} from "@/store/modules/workspace.ts";

const CreateInvitedUserForm = () => {
    const inviteState = useSelector((state: RootState) => state.invite);
    const authState = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const dispatch = useDispatch<any>()

    function gotoModal() {
        dispatch(application.action.readApplication())
        dispatch(workspace.action.readWorkSpaceByUserId({userId: authState.userInfo.userId}))
        navigate(RouteConstant.auth.success.path);
    }

    const handleCreateUser = async () => {
        const request: InviteRegistrationRequest = {
            ...formik.values,
            userWorkspaceId: inviteState?.verifiedInviteResponse?.inviteWorkspaceId
        }
        const action = await dispatch(invite.action.inviteRegistration({data: request}));
        const response = action.payload as InviteRegistrationResponse;
        if (response.responseCode == "00") {
            dispatch(auth.mutation.setCoreAuthState(response));
            navigate(RouteConstant.dashboard.dashboard.path)
            gotoModal()
        }
    }

    const formik = useFormik({
        initialValues: {
            ...InviteRegistrationRequestInit,
            userEmail: inviteState?.verifiedInviteResponse?.userEmail,
            inviteId: inviteState?.verifiedInviteResponse?.inviteId
        },
        onSubmit: handleCreateUser,
        // validationSchema: InviteValidation.createInvitedUser,
    })
    return (
        <>
            <form className={"form-field-wrapper"} style={{width: '100%'}}>
                <div style={{marginBottom: "2rem"}}>
                    <BaseInput
                        formik={formik}
                        name={"userFullName"}
                        // className={"form-input login w-input"}
                        className={"form-input w-input form-input-user"}
                        placeholder="Enter Full Name"
                        label={"Full Name"}
                    />
                </div>
                <div style={{marginBottom: "2rem"}}>
                    <BaseInput formik={formik} name={"userEmail"}
                               placeholder="Enter your email address"
                        // className={"form-input login w-input"}
                               className={"form-input w-input form-input-user"}
                        // startIcon={EmailIcon}
                               label={"Email Address"}
                               disabled={true}
                    />
                </div>
                <div style={{marginBottom: "2rem"}}>
                    <BaseInput formik={formik}
                               name={"userPassword"}
                               className={"form-input w-input form-input-user"}
                               placeholder="Enter your password"
                               label={"Password"}
                    />
                </div>
                <BaseInput
                    type="submit"
                    formik={formik}
                    name={"submit"}
                    value={"Create Account"}
                    loading={inviteState.loading}
                    className={"button max-width-full login w-button"}
                />
                {/*<BaseButton variant={"primary"} text={"Create Account"} isLoading={userState?.loading} onClick={() => {*/}
                {/*    formik.handleSubmit()*/}
                {/*}}/>*/}
            </form>
        </>
    )

}

export default CreateInvitedUserForm


{/*<BasePhoneNumberInput formik={formik} inputName={"userPhone"}*/
}
{/*                      selectInputName={"userCountryCode"}*/
}
{/*                      inputPlaceholder={"Phone number"}*/
}
{/*                      label={"Phone Number"}*/
}
{/*                      baseInputProps={{*/
}
{/*                          startIcon: PhoneIcon*/
}
{/*                      }}*/
}
{/*                      style={{flex: 1}}*/
}
{/*/>*/
}

// props: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>